import AdjustedBasicPayTable from './Table';
import styles from './index.module.scss';

type AdjustedBasicPayProps = {
	selectedPayrollId: string;
	headerData: any;
	setIsUniversalLoading: any;
	setRemainingCount: any;
	setInvalidCount: any;
	showSteps: boolean;
};

const AdjustedBasicPayComponent = (props: AdjustedBasicPayProps) => {
	const {
		selectedPayrollId,
		headerData,
		setIsUniversalLoading,
		setRemainingCount,
		setInvalidCount,
		showSteps,
	} = props;

	return (
		<>
			<div className={styles['adjusted-net-pay__table']}>
				<AdjustedBasicPayTable
					selectedPayrollId={selectedPayrollId}
					setIsUniversalLoading={setIsUniversalLoading}
					headerData={headerData}
					setRemainingCount={setRemainingCount}
					setInvalidCount={setInvalidCount}
					showSteps={showSteps}
				/>
			</div>
		</>
	);
};

export default AdjustedBasicPayComponent;
